import React from "react";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";

const TooltipLists = ({ title, content }) => {
  return (
    <View
      style={{
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        paddingTop: 10,
      }}
    >
      <Text
        size={12}
        style={{
          color: COLORS.lightGray,
          width: "15%",
          justifyContent: "flex-start",
        }}
      >
        {title}
      </Text>
      <Text
        size={14}
        style={{
          color: COLORS.lightGray5,
          width: "85%",
          justifyContent: "flex-start",
          marginLeft: 20,
        }}
      >
        {content}
      </Text>
    </View>
  );
};
const ChartTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      // <div className="custom-tooltip">
      //     <p className="label">{`${label} : ${payload[0].value}`}</p>
      //     {/* <p className="intro">{getIntroOfPage(label)}</p> */}
      //     <p className="desc">Anything you want can be displayed here.</p>
      // </div>
      (<View
        style={{
          backgroundColor: COLORS.white,
          padding: 10,
          width: 200,
          borderRadius: 10,
        }}
      >
        <TooltipLists title={"label"} content={label} />
        <View style={{ width: "100%" }}>
          {payload?.map(({ payload }: any, index: any) => (
            <View
              style={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "100%",
              }}
              key={index.toString()}
            >
              <TooltipLists title={"name"} content={payload.name} />
              <TooltipLists title={"uv"} content={payload.uv} />
              <TooltipLists title={"pv"} content={payload.pv} />
              <TooltipLists title={"date"} content={payload.date} />
            </View>
          ))}
        </View>
      </View>)
    );
  }
  return null;
};

export default React.memo(ChartTooltip);
